<template>
  <router-view />
  <v-overlay v-if="load" class="page_loading" persistent :model-value="load" />
</template>
<script setup lang="ts">
import { computed } from "vue";
const load = computed(() => window.$load?.value);
</script>
